// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1-jT8","notes":"Notes_notes__3Pfog"};